import { signOut } from '@/utils/firebase.utils';
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { revertAll } from '@/state/slices/userSlice';

const LogoutPage = () => {
    
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        async function removeUser() {
            dispatch(revertAll())
            await signOut();
            setTimeout(() => {
                navigate('/')
            }, 1000);
        }
        removeUser();

    }, [])

    return (
        <div></div>
    )
}

export default LogoutPage